import Card from '../components/Card'
import { Link } from 'react-router-dom'
import noimage from "../assets/mocks/noimage.png"

const PublicationBanner = ({ content }: any) => {
    return (
        <div className="row g-2 mx-5">
            {
                content?.map((publication: any) => (
                    <Card
                        key={"publ" + publication.slug}
                        height="38rem !important"
                        class="col-12 col-md-3 col-sm-12 "
                        imageClass="pt-5 mh-25rem object-contain"
                        bodyClass="fs-6 text-truncate-two"
                        titleTextColor="text-primary"
                        subtitleTextColor="text-grey-700"
                        image={publication?._embedded ? publication?._embedded['wp:featuredmedia'][0]?.source_url : noimage}
                        title={publication.title.rendered}
                        date={new Date(publication.date).toDateString().split(' ').slice(1).join(' ')}
                        body={publication.content.rendered}
                        link={"/publications/" + publication.slug}
                    />
                ))
            }
            <div className="col-12 col-md-3 col-sm-12 overflow-hidden">
                <div className="card align-text-bottom h-100">
                    <img loading="lazy" src="/media/publications/publications-view-more.webp" className="h-100 img-fluid" alt="Image" />
                    <div className="card-img-overlay bg-primary opacity-75">

                    </div>
                    <div className="card-img-overlay d-flex align-items-md-end">
                        <Link to="/publications"><h2 className="card-title text-start opacity-100 text-secondary h1 fw-bolder">CHECK THE REST OF OUR PUBLICATIONS</h2></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PublicationBanner